import assign = require('object-assign');
import customer, { isResponsible as isCustomer } from './customer';
import event, { isResponsible as isEvent } from './events';
import job, { isResponsible as isJob } from './jobs';
import nodes, { isResponsible as isNodes } from './nodes';
import measurements, { isResponsible as isMeasurements } from './measurements';
import software, { isResponsible as isSoftware } from './software';
import states, { isResponsible as isStates } from './states';
import systems, { isResponsible as isSystems } from './systems';
import inventory, { isResponsible as isInventory } from './inventory';

function callReducer(state, action, reducer) {
    const { requesterId } = action.meta;
    return assign({}, state, {
        [requesterId]: reducer(state[requesterId], action)
    });
}

function isAnyoneLoading(state) {
    return Object.keys(state).reduce((isLoading, key) => {
        if (isLoading) {
            return isLoading;
        }

        const subState = state[key];

        if (!subState) {
            return false;
        }

        if (subState.loading == null) {
            isLoading = isAnyoneLoading(subState);
        } else {
            isLoading = subState.loading;
        }

        if (isLoading) {
            console.debug('isLoading', key, isLoading);
        }

        if (subState.error) {
            console.warn('hasErrors', key, subState.error);
        }

        if (subState.data) {
            if (subState.data.length == null) {
                console.debug('data length', key, Object.keys(subState.data).length);
            } else {
                console.debug('data length', key, subState.data.length);
            }
        }

        return isLoading;
    }, false);
}

export default function widgetData(state = { isLoading: null }, action) {
    let isTargetState = false;

    if (isCustomer(action)) {
        state = callReducer(state, action, customer);
        isTargetState = true;
    }

    if (isEvent(action)) {
        state = callReducer(state, action, event);
        isTargetState = true;
    }

    if (isJob(action)) {
        state = callReducer(state, action, job);
        isTargetState = true;
    }

    if (isNodes(action)) {
        state = callReducer(state, action, nodes);
        isTargetState = true;
    }

    if (isMeasurements(action)) {
        state = callReducer(state, action, measurements);
        isTargetState = true;
    }

    if (isSoftware(action)) {
        state = callReducer(state, action, software);
        isTargetState = true;
    }

    if (isStates(action)) {
        state = callReducer(state, action, states);
        isTargetState = true;
    }

    if (isSystems(action)) {
        state = callReducer(state, action, systems);
        isTargetState = true;
    }
    
    if (isInventory(action)) {
        state = callReducer(state, action, inventory);
        isTargetState = true;
    }

    if (isTargetState) {
        state.isLoading = isAnyoneLoading(state);
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/index.ts